export default __webpack_public_path__ + "static/media/zine-landscape.ab611a6b.jpg";